import React from "react";
import "./deathDashboard.css";
import addIcon from "../../assets/images/DeathModuleNew/addIcon.png";
import protectedImg from "../../assets/images/DeathModuleNew/protected.svg";

import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setActiveStep } from "../../redux/slices/loginSlice";
import { ToolTipCreator } from "../../helpers/ToolTipCreator";

export const ImportantDocumnetsDashboard = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const data = [
    {
      id: 1,
      name: "New Doc",
      status: "link",
    },
    {
      id: 2,
      name: "Old Doc",
      status: "link",
    },
    {
      id: 3,
      name: "Personal",
      status: "link",
    },
    {
      id: 4,
      name: "MyFile",
      status: "link",
    },
  ];

  return (
    <div style={{ height: "47%" }}>
      <div
        style={{
          background: "white",
          borderRadius: "8px",
          padding: "1rem",
          marginBottom: "1rem",
          height: "49%",
          cursor:"pointer",
          pointerEvents: props.role === "trustee" ? "none" : "",
        opacity: props.role === "trustee" ? "0.5" : "1",
        }}
        onClick={() => {
          dispatch(setActiveStep(10));
          history.push("/protector/death");
        }}
      >
        {" "}
        <div
          className="cardHeading"
          style={{
            marginTop: "8px",
            marginBottom: "8px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          IMPORTANT DOCUMENTS
          <ToolTipCreator name={"Death_Important_Documents"}/>
        </div>
          <div className="uploadButtons" style={{ width: "20px" }}>
            {" "}
            <div className="upload" style={{ width: "20px", height: "20px" }}>
              <img
                src={addIcon}
                width={12}
                height={12}
                style={{ width: "12px", height: "12px" }}
                alt="addicon"
              ></img>
            </div>
          </div>
        </div>
        <div
          style={{
            height: "10rem",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "700",
              fontFamily: "Poppins",
              fontSize: "14px",
              flexDirection:"column"
            }}
          >
          {props.role !== "trustee" ? 
          "SECURED! We have your Important Documents guarded behind multiple levels of protection." : "This information will be available to you soon!"}
            <img
            src={protectedImg}
            style={{ width: "50px", height: "50px", marginTop:"8px" }}
            alt="protectedImg"
          ></img>
          </div>
        </div>
      </div>
      <div
        style={{
          background: "white",
          borderRadius: "8px",
          padding: "1rem",
          marginBottom: "1rem",
          height: "48%",
          cursor:"pointer",
          pointerEvents: props.role === "trustee" ? "none" : "",
        opacity: props.role === "trustee" ? "0.5" : "1",
        }}
        onClick={() => {
          dispatch(setActiveStep(10));
          history.push("/protector/death");
        }}
      >
        {" "}
        <div
          className="cardHeading"
          style={{
            marginTop: "8px",
            marginBottom: "8px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          INSURANCE POLICIES
          <div className="uploadButtons" style={{ width: "20px" }}>
            {" "}
            <div className="upload" style={{ width: "20px", height: "20px" }}>
              <img
                src={addIcon}
                width={12}
                height={12}
                style={{ width: "12px", height: "12px" }}
                alt="addicon"
              ></img>
            </div>
          </div>
        </div>
        <div
          style={{
            height: "10rem",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "700",
              fontFamily: "Poppins",
              fontSize: "14px",
              flexDirection:"column"
            }}
          >
          {props.role !== "trustee" ? 
          "SECURED! We have your Insurance Policies guarded behind multiple levels of protection." : "This information will be available to you soon!"}
            <img
            src={protectedImg}
            style={{ width: "50px", height: "50px", marginTop:"8px" }}
            alt="protectedImg"
          ></img>
          </div>
        </div>
      </div>
    </div>
  );
};
